
import React from "react";
import { useTheme } from "@material-ui/core";
import HvIconBase from "./IconBase";

const sizeSelector = (iconSize, height, width) => {
  if (height && width) {
    return { width, height };
  }

  switch (iconSize) {
    case "XS":
      return { width: 12, height: 12 };
    default:
    case "S":
      return { width: 16, height: 16 };
    case "M":
      return { width: 32, height: 32 };
    case "L":
      return { width: 96, height: 96 };
  }
};

const PingPong = ({
  color,
  iconSize = "S",
  viewbox = "0 0 16 16",
  height,
  width,
  semantic,
  inverted = false,
  svgProps,
  ...others
}) => {
  const theme = useTheme();
  const getColor = c => theme.palette?.[c] || c;
  const colorArray = 
    (typeof color === "string" && [getColor(color)]) ||
    (Array.isArray(color) && color.map?.(getColor)) ||
    [theme.palette.acce1];

  if (semantic) {
    colorArray[0] = theme.palette?.[semantic] || colorArray[0];
  }

  if (inverted && colorArray[1]) {
    colorArray[1] = colorArray[0];
    colorArray[0] = "none";
  }

  const size = sizeSelector(iconSize, height, width);

  return (
    <HvIconBase name="PingPong" iconSize={iconSize ?? "S"} {...others}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox={viewbox} height={size.height} width={size.width}   focusable={false} {...svgProps}>
  <path fill={colorArray[0]} className="color0"  d="M14.05844 1.94a6.628 6.628 0 00-10.667 7.543l-3.391 3.39 3.124 3.124 3.39-3.39a6.628 6.628 0 007.544-10.667zm-7.108 9.757l-.645-.308-.5.5-2.677 2.677-1.7-1.7 2.672-2.669.505-.505-.307-.644a5.6 5.6 0 01-.474-3.28l6.4 6.4a5.60807 5.60807 0 01-3.274-.471zm6.394-1.1a5.57405 5.57405 0 01-1.9 1.229l-7.188-7.187-.1-.069a5.611 5.611 0 119.188 6.027z" />
</svg>
    </HvIconBase>
)};

PingPong.propTypes = HvIconBase.propTypes;

export default PingPong;